import React from 'react'
import { Container, Table, Row, Col, Label, Button } from 'reactstrap'
import { PackagingSlipModalController } from './modal/PackagingSlipModalController'
import DateTextField from '../view/DateTextField'
import NumberTextField from '../view/NumberTextField'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { addUserTimeZoneJson } from '../model/DateConverter'
import { Account } from '../model/Account'
import {JustDate} from '../model/JustDate';
import { Quote } from '../model/Quote'
import {
    getQuote,
    getTeamNames,
} from '../model/request/quotes'
import {
    getFilesFromManyQuoteIDs,
    downloadFile,
} from '../model/request/files'
import {
    downloadInvoicePDF,
    downloadPackageSlip,
    downloadPDF,
} from '../model/request/pdf'
import {
    InfoButton,
} from '../view/InfoButton'
import {
    MultipleStringsInColumnArrowsView,
} from '../view/MultipleValuesInColumnArrowsView'
import dateFormat from 'dateformat'
import SimpleDropdown from '../view/DropDownView'
import TeamDropdown from '../view/TeamDropdown'

class ProductionViewController extends React.Component {

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        this.state = {
            'jobs': [],
            'files': {},
            'teams': [],
            'account': account,
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()

        getTeamNames().then(
            (result) => {
                this.setState({
                    'teams': result.data.teams,
                })
            },
            (error) => {
                this.props.showError(error)
            }
        )

        this.props.getDataFunc().then(
            (result) => {
                const jobs = addUserTimeZoneJson(result.data.jobs)
                this.setState({
                    'jobs': jobs.map((job) => {
                        job.cost_without_shipping = job.total_price - job.shipping_cost
                        return job
                    }),
                })
                this.getFiles(jobs.map((job) => job.quote_id))

                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    getFiles(quoteIds) {
        quoteIds = [...new Set(quoteIds)]
        getFilesFromManyQuoteIDs(quoteIds).then(
            (result) => {
                const files = this.state.files

                for (let i = 0; i < quoteIds.length; i++) {
                    files[quoteIds[i]] = []
                }

                for (let i = 0; i < result.data.files.length; i++) {
                    files[result.data.files[i].quote_id].push(result.data.files[i])
                }

                this.setState({
                    'files': files,
                })
            },
            (error) => {
                this.props.showError(error)
            }
        )
    }

    totalPriceSelected(isThermoformed) {
        let total = 0.0
        for (let i = 0; i < this.state.jobs.length; i++) {
            if (this.state.jobs[i].is_checked &&
                isThermoformed === this.state.jobs[i].is_thermoformed) {
                total += this.state.jobs[i].total_price
            }
        }

        return total
    }


    // MARK: render

    renderRow() {
        return this.state.jobs.map((job, index) =>
            this.props.createTableRow(job, index, this)
        )
    }

    renderTotalPrices(label, value) {
        return <Col>
            <Label style={{
                'fontSize': '18px',
                    'fontWeight': '450',
                    'marginRight': '8px',
                }}>{label}</Label>
                <Label style={{
                    'fontSize': '18px',
                    'fontWeight': '400',
                }}><span text={moneyText(value)}>{formatAsDollarValue(value)}</span></Label>
        </Col>
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <InfoButton
                            id={'backlogsearchdesc'}
                            message={
                                this.props.infoMessage
                            } />
                    </Col>
                </Row>
                <Row>
                    {this.renderTotalPrices('Total Price:',
                        this.state.jobs.length > 0 ?
                        this.state.jobs.map((x) => x.total_price)
                            .reduce((l, r) => l+r) : 0)}
                    {this.renderTotalPrices('Engraved:',
                        this.state.jobs.length > 0 ?
                            this.state.jobs.map((x) =>
                                x.is_thermoformed ? 0.0 : x.total_price
                            ).reduce((l, r) => l+r) : 0)
                        }
                    {this.renderTotalPrices('Thermoformed:',
                        this.state.jobs.length > 0 ?
                            this.state.jobs.map((x) =>
                                x.is_thermoformed ? x.total_price : 0.0
                            ).reduce((l, r) => l+r) : 0)
                        }

                </Row>
                <Row>
                    <Col>
                        <Button
                            color='primary'
                            onClick={(e) => {
                                const url = '/api/csv/' + this.props.csvfilename + '.csv'
                                window.location.href = url
                            }}>Download CSV</Button>
                    </Col>
                </Row>
                <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        {this.props.tableHeader}
                    </thead>
                    <tbody>
                        {this.renderRow()}
                        <tr>
                            <td><Label
                                style={{
                                    'fontWeight': '500',
                                }}>Cumulative</Label></td>
                            {[...Array(this.props.columnsBeforeTotalPrice).keys()].map((value, index) => <td/>)}
                            <td></td>
                            <td><span text={moneyText(this.totalPriceSelected(false))}>{formatAsDollarValue(this.totalPriceSelected(false))}</span></td>
                            <td><span text={moneyText(this.totalPriceSelected(true))}>{formatAsDollarValue(this.totalPriceSelected(true))}</span></td>
                            {[...Array(this.props.columnsAfterTotalPrice ?? 1).keys()]
                                .map((value, index) => <td/>)}
                        </tr>
                    </tbody>
                </Table></Container></Col></Row>
            </Container>
        )
    }
}

function ProductionCreateHeader(label, minWidth='130px') {
    return <th className="text-center label-weight"
        style={{'minWidth': minWidth}}>{label}</th>
}

function ProductionCreateHeaderRow(beginginHeaders=<></>, endingHeaders=<></>) {
    return <tr>
        {beginginHeaders}
        {ProductionCreateHeader('Job')}
        {ProductionCreateHeader('Customer')}
        {ProductionCreateHeader('Files')}
        {ProductionCreateHeader('Promise Date')}
        {ProductionCreateHeader('Engraved')}
        {ProductionCreateHeader('Thermoformed')}
        {endingHeaders}
    </tr>
}


function ProductionCreateLinkColumn(varName='job_name', baseLink='/scheduler/') {
    function f(job, index, context) {
        return <td><Label><a href={baseLink + job.quote_id}>{job[varName]}</a></Label></td>
    }
    return f
}
function ProductionCreateLabelColumn(varName) {
    function f(job, index, context) {
        return <td><Label>{job[varName]}</Label></td>
    }
    return f
}

function ProductionCreateLabelDateColumn(varName) {
    function f(job, index, context) {
        return <td><Label>{
            job[varName] ?
            <span text={dateOffsetText(job[varName])}>{dateFormat(job[varName].toDateTime(), 'mmmm d, yyyy')}</span>
            : ""
            }</Label></td>
    }
    return f
}

function ProductionCreateNumberInputColumn(varName, onUpdate) {
    function f(job, index, context) {
        return <td>
            <NumberTextField
                style={{
                    'textAlign': 'right',
                }}
                showDigitsKeyPad={
                    context.state.account.settings.numbers_calculator_show
                }
                value={job[varName]}
                onChange={(e) => {
                    job[varName] = e.target.value
                    context.setState()
                    if (onUpdate) {
                        onUpdate(job, index, context, e.target.value)
                    }
                }}
            />
        </td>
    }
    return f
}

function ProductionCreateMoneyColumn(varName) {
    function f(job, index, context) {
        return <td><Label><span text={moneyText(job[varName])}>{formatAsDollarValue(job[varName])}</span></Label></td>
    }
    return f
}

function ProductionCreateCustomDropDownColumn(varName='shipping_method') {
    function f(job, index, context) {
        const trackingOptions = [
            'Fed Ex',
            'UPS',
        ]
        if (job.shipping_method &&
            !(trackingOptions.indexOf(job.shipping_method) !== -1)) {
            trackingOptions.push(job.shipping_method)
        }
        trackingOptions.push('Other')
        return <td><SimpleDropdown
                index={trackingOptions.indexOf(job.shipping_method)}
                values={trackingOptions}
                onChange={(index) => {
                    if (index === trackingOptions.length -1) {
                        context.props.showTextFieldModal('Project Manager', (value) => {
                            job.shipping_method = value
                            context.setState({})
                        })
                    } else {
                        job.shipping_method = trackingOptions[index]
                        context.setState({})
                    }
                }} />
        </td>
    }
    return f
}

// Same shape as ProductionCreateCustomDropDownColumn above, but the options
// come from the recently-active teams the screen fetched, and picking one
// saves straight away (a targeted quote PUT) rather than waiting for the
// row's save button - there isn't one for this column.
function ProductionCreateTeamDropDownColumn() {
    function f(job, index, context) {
        return <td><TeamDropdown
            {...context.props}
            quoteId={job.quote_id}
            value={job.team_name}
            teams={context.state.teams} />
        </td>
    }
    return f
}

function ProductionCreateFileDownloadColumn() {
    function f(job, index, context) {
        if (!(job.quote_id in context.state.files)) {
            return <td><Label>Loading ...</Label></td>
        }

        const values = context.state.files[job.quote_id].map((file, index) => file.name)

        return <td><SimpleDropdown
            index={-1}
            values={['Invoice', 'Packaging Slip', 'Quote', ...values]}
            onChange={(index) => {
                if (index === 0) {
                    downloadInvoicePDF(job.quote_id, job.job_name)
                } else if (index === 1) {
                    context.props.turnOnLoader()
                    getQuote(job.quote_id)
                        .then(
                            (result) => {
                                const quote = Quote.from(result.data.quote)
                                context.props.turnOffLoader()
                                context.props.showModal(
                                    <PackagingSlipModalController
                                        quote={quote}
                                    />
                                )
                            },
                            (error) => {
                                context.props.showError(error)
                                context.props.turnOffLoader()
                            }
                        )
                } else if (index === 2) {
                    job.id = job.quote_id
                    downloadPDF(job, true)
                } else {
                    index -= 3
                    downloadFile(context.state.files[job.quote_id][index].id,
                        context.state.files[job.quote_id][index].name)
                }
            }} /></td>
    }
    return f
}

function ProductionCreateMultipleStringsColumn(varName) {
    function f(job, index, context) {
        return <td><MultipleStringsInColumnArrowsView
            values={job[varName]}
            onChange={(newArray) => {
                context.setState((state) => {
                    state.jobs[index][varName] = newArray
                    return {
                        'jobs': state.jobs,
                    }
                })
            }}
            /></td>
    }
    return f
}

function ProductionCreateRow(containsDateInCheck=true, pre=[], post=[], mid=null) {

    if (!mid) {
        mid = [
            ProductionCreateLinkColumn(),
            (job, index, contex) => {
                return <td><Label>
                    <a href={'/customerreport?filter=All&company=' + job.customer_name}
                        >{job.customer_name}</a>
                </Label></td>
            },
            ProductionCreateFileDownloadColumn(),
            ProductionCreateLabelDateColumn('customer_promise_date'),
            (job, index, contex) => {
                if (job.is_thermoformed) {
                    return <><td></td><td>
                        <Label><span text={moneyText(job['total_price'])}>{formatAsDollarValue(job['total_price'])}</span></Label>
                    </td></>
                } else {
                    return <><td>
                        <Label><span text={moneyText(job['total_price'])}>{formatAsDollarValue(job['total_price'])}</span></Label>
                    </td><td></td></>
                }
            }
        ]
        if (containsDateInCheck) {
            post.push(
                (job, index, context) => <td>
                    <input type="checkbox" checked={job.is_checked}
                    style={{
                        'display': 'inline-block',
                    }}
                    onChange={(e) => {
                        const jobs = context.state.jobs
                        jobs[index].is_checked = !jobs[index].is_checked

                        if (jobs[index].is_checked && jobs[index].date_picked === undefined) {
                            jobs[index].date_picked = new JustDate()
                        }

                        context.setState({
                            'jobs': jobs,
                        })
                    }} />
                    <div style={{
                        'display': 'inline-block',
                        'width': 'min(600px, 100% - 22px)',
                        'marginLeft': '8px',
                    }}>
                    <DateTextField
                        style={{
                            'display': 'inline-block',
                        }}
                        showModal={context.props.showModal}
                        closeModal={context.props.closeModal}
                        value={job.date_picked}
                        onChange={(d) => {
                            const jobs = context.state.jobs
                            jobs[index].date_picked = d
                            context.setState({
                                'jobs': jobs,
                            })
                        }}
                        />
                    </div>
                </td>
            )
        } else {
            mid.push(
                (job, index, context) => <td>
                    <input type="checkbox" checked={job.is_checked}
                    style={{
                        'display': 'inline-block',
                    }}
                    onChange={(e) => {
                        const jobs = context.state.jobs
                        jobs[index].is_checked = !jobs[index].is_checked
                        context.setState({
                            'jobs': jobs,
                        })
                    }} />
                </td>
            )
        }
        post = post.concat([
            (job, index, context) => {
                return <td><Button color="success"
                    onClick={(e) => {
                        context.props.saveJob(job, context)
                    }}>Save</Button>
                </td>
            },
        ])
    }

    function f(job, index, context) {
        return <tr>
            {pre.map((func, i) => func(job, index, context))}
            {mid.map((func, i) => func(job, index, context))}
            {post.map((func, i) => func(job, index, context))}
        </tr>
    }
    return f
}

export {
    ProductionViewController, ProductionCreateHeader,
    ProductionCreateHeaderRow, ProductionCreateRow,
    ProductionCreateLabelColumn, ProductionCreateMoneyColumn,
    ProductionCreateNumberInputColumn,
    ProductionCreateCustomDropDownColumn,
    ProductionCreateTeamDropDownColumn,
    ProductionCreateLabelDateColumn,
    ProductionCreateMultipleStringsColumn,
    ProductionCreateFileDownloadColumn,
}
